module.exports = __webpack_public_path__ + "static/img/tengxun.fdd9e9e0.svg";